import { ReactElement } from 'react';
import React from 'react';
import { TotalItem } from 'devextreme-react/data-grid';

interface IDrawManualTotalItemsProps {
    drawId: number;
    drawNumber: number;
    drawFinalized: boolean;
    toggleArray: [];
}

export const DrawManualTotalItems = ({
    drawId,
    drawNumber,
    drawFinalized,
    toggleArray,
}: IDrawManualTotalItemsProps): ReactElement[] => {
    const precision = drawFinalized ? 0 : 2;
    if (toggleArray[drawNumber] === true) {
        return [
            <TotalItem
                name={`drawItems-borrowerRequest-${drawId}-${drawNumber}`}
                showInColumn={`drawItems-borrowerRequest-${drawId}-${drawNumber}`}
                summaryType='custom'
                valueFormat={{ type: 'currency', precision: precision }}
            />,
            <TotalItem
                name={`drawItems-funded-${drawId}-${drawNumber}`}
                showInColumn={`drawItems-funded-${drawId}-${drawNumber}`}
                summaryType='custom'
                valueFormat={{ type: 'currency', precision: precision }}
            />,
            <TotalItem
                name={`drawItems-inspection-${drawId}-${drawNumber}`}
                showInColumn={`drawItems-inspection-${drawId}-${drawNumber}`}
                summaryType='custom'
                valueFormat={{ type: 'currency', precision: precision }}
            />,
            // <TotalItem
            //     name={`OutOfBalance${drawId}-${drawNumber}`}
            //     showInColumn={`OutOfBalance${drawId}-${drawNumber}`}
            //     summaryType='custom'
            //     valueFormat={{ type: 'currency', precision: precision }}
            // />,
        ];
    } else {
        if (drawFinalized) {
            return [
                <TotalItem
                    name={`drawItems-funded-${drawId}-${drawNumber}`}
                    showInColumn={`drawItems-funded-${drawId}-${drawNumber}`}
                    summaryType='custom'
                    valueFormat={{ type: 'currency', precision: precision }}
                />,
            ];
        } else {
            return [
                <TotalItem
                    name={`drawItems-borrowerRequest-${drawId}-${drawNumber}`}
                    showInColumn={`drawItems-borrowerRequest-${drawId}-${drawNumber}`}
                    summaryType='custom'
                    valueFormat={{ type: 'currency', precision: precision }}
                />,
            ];
        }
    }
};
